module.exports = __webpack_public_path__ + "static/media/STHiFi5.23fbbfb1.png";